import {Component, OnInit, ViewChild} from '@angular/core';
import {Compbaser} from "../../../components/compbaser";
import {Store} from "@ngrx/store";
import {IAppState} from "../../../store/state/app.state";
import {StoreSelectorsService} from "../../../services";
import {InsertionDirective} from "../../../directtives/insertion.directive";
import {compareIds} from "../../../common";
import {IBlockLabelsRecords} from "../scene-blocks/block-constants";
import {ISceneBlock} from "../../../interfaces";

@Component({
    selector: 'app-block-loader',
    templateUrl: './block-loader.component.html',
    styleUrls: ['./block-loader.component.scss'],
})
export class BlockLoaderComponent extends Compbaser implements OnInit {

    private sceneId: string;
    private sceneItem: ISceneBlock;
    private selectedPlayerId = '-1';
    private blockLabelRecords: IBlockLabelsRecords;

    constructor(private store: Store<IAppState>, private storeSelector: StoreSelectorsService) {
        super();
        this.blockLabelRecords = this.storeSelector.blockLabels;
    }

    @ViewChild(InsertionDirective, {static: true}) insertDirective: InsertionDirective;

    ngOnInit() {
        this.cod(
            this.storeSelector.listenPlayerDataOfSelectedSceneItemId().subscribe((val) => {
                // console.log('player selected  ' + val.sceneItem.$.player);
                this.sceneId = val.sceneId;
                this.sceneItem = val.sceneItem;
                if (this.selectedPlayerId === '-1')
                    return this.dynamicLoadComponent(val.sceneItem.$.player, val.sceneItem.$.id);
                if (compareIds(this.selectedPlayerId, val.sceneItem.$.id))
                    return;
                this.dynamicLoadComponent(val.sceneItem.$.player, val.sceneItem.$.id);
            })
        );
    }

    private dynamicLoadComponent(i_blockLabelId, i_playerId) {
        this.cod(
            this.storeSelector.getSceneMime(this.sceneId)
                .subscribe((mimeType) => {
                    this.selectedPlayerId = String(i_playerId);
                    const blockLabelId = String(i_blockLabelId);
                    const component = this.storeSelector.getComponentForBlock(blockLabelId, mimeType).component;
                    const viewContainerRef = this.insertDirective.viewContainerRef;
                    viewContainerRef.clear();
                    const componentRef = viewContainerRef.createComponent(component);
                    componentRef.instance['data'] = Math.random();
                })
        );
    }
}
